import {
  IDynamicItemStyles,
  isIDynamicBindableValue,
  isIDynamicBindableValueCombination,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export function attachStyles(
  element: HTMLElement,
  styles: Partial<IDynamicItemStyles>,
) {
  const { classes, style, variables } = styles;

  if (classes?.length) {
    element.classList.add(
      ...(classes.filter((item) => typeof item === 'string') as string[]),
    );
  }

  if (style) {
    Object.keys(style).forEach((styleProperty) => {
      const valueToSet = style[styleProperty];
      if (
        !isIDynamicBindableValue(valueToSet) &&
        !isIDynamicBindableValueCombination(valueToSet)
      ) {
        element.style[styleProperty as unknown as number] = valueToSet;
      } else {
        console.error(
          'Setting style property as IDynamicBindableValue is not supported yet.',
        );
      }
    });
  }

  if (variables) {
    Object.keys(variables).forEach((variableProperty) => {
      if (typeof variables[variableProperty] !== 'string') {
        return;
      }

      element.style.setProperty(
        variableProperty,
        variables[variableProperty] as string,
      );
    });
  }
}
